<p-confirmDialog
  [acceptLabel]="config.CONFIRMATION.DEFAULT.ACCEPT_KEY | translate"
  [rejectLabel]="config.CONFIRMATION.DEFAULT.REJECT_KEY | translate">
</p-confirmDialog>
